<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productProfile.productDetail') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productProfile.pageTitle'),
            ref: '/admin/product-profiles'
          },
          {
            text: $t('productProfile.detail'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <a-tabs :default-active-key="index" v-model="index" @change="onTapChange">
          <a-tab-pane :key="1" :tab="$t('productProfile.summary')">
            <SummaryTable ref="summary_table" forcerender />
          </a-tab-pane>
          <a-tab-pane :key="2" :tab="$t('productProfile.purchaseInvoice')">
            <PurchaseInvoice ref="purchase_invoice" />
          </a-tab-pane>
          <a-tab-pane :key="3" :tab="$t('productProfile.transfer')">
            <Transfer ref="transfer" />
          </a-tab-pane>
          <a-tab-pane :key="4" :tab="$t('productProfile.received')">
            <TransferReceived ref="transfer_received" />
          </a-tab-pane>
          <a-tab-pane :key="5" :tab="$t('productProfile.sale')">
            <SaleInvoice ref="sale_invoice" /> 
          </a-tab-pane>
          <a-tab-pane :key="6" :tab="$t('productProfile.writeOff')">
            <WriteOff ref="write_off" />
          </a-tab-pane>
          <a-tab-pane :key="7" :tab="$t('productProfile.returnToVendor')">
            <ReturnToVendor ref="return_to_vendor" />
          </a-tab-pane>
          <a-tab-pane :key="8" :tab="$t('productProfile.returnFromVendor')">
            <ReturnFromVendor ref="return_from_vendor"/>
          </a-tab-pane>
        </a-tabs>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import SummaryTable from './detail-components/sumarry-table.vue'
import PurchaseInvoice from './detail-components/purchas-invoice.vue'
import Transfer from './detail-components/transfer.vue'
import TransferReceived from './detail-components/transfer-received.vue'
import SaleInvoice from './detail-components/sale-invoice.vue'
import WriteOff from './detail-components/write-off.vue'
import ReturnToVendor from './detail-components/return-to-vendor.vue'
import ReturnFromVendor from './detail-components/return-from-vendor.vue'
export default {
  name: 'productDetail',
  components: {
    SummaryTable,
    PurchaseInvoice,
    Transfer,
    TransferReceived,
    SaleInvoice,
    WriteOff,
    ReturnToVendor,
    ReturnFromVendor
  },
  data() {
    return {
      index: 1
    }
  },
  methods: {
    onTapChange(key) {
      this.index = key
      if (key == 2) {
        if (this.$refs.purchase_invoice == undefined) {
          this.$nextTick(() => this.$refs.purchase_invoice.fetchData())
        } else {
          this.$refs.purchase_invoice.fetchData()
        }
      }
      if (key == 3) {
        if (this.$refs.transfer == undefined) {
          this.$nextTick(() => this.$refs.transfer.fetchData())
        } else {
          this.$refs.transfer.fetchData()
        }
      }
      if (key == 4) {
        if (this.$refs.transfer_received == undefined) {
          this.$nextTick(() => this.$refs.transfer_received.fetchData())
        } else {
          this.$refs.transfer_received.fetchData()
        }
      }
      if (key == 5) {
        if (this.$refs.sale_invoice == undefined) {
          this.$nextTick(() => this.$refs.sale_invoice.fetchData())
        } else {
          this.$refs.sale_invoice.fetchData()
        }
      }
      if (key == 6) {
        if (this.$refs.write_off == undefined) {
          this.$nextTick(() => this.$refs.write_off.fetchData())
        } else {
          this.$refs.write_off.fetchData()
        }
      }
      if (key == 7) {
        if (this.$refs.return_to_vendor == undefined) {
          this.$nextTick(() => this.$refs.return_to_vendor.fetchData())
        } else {
          this.$refs.return_to_vendor.fetchData()
        }
      }
      if (key == 8) {
        if (this.$refs.return_from_vendor == undefined) {
          this.$nextTick(() => this.$refs.return_from_vendor.fetchData())
        } else {
          this.$refs.return_from_vendor.fetchData()
        }
      }
    },
    fetchSummary() {
      this.$refs.summary_table.fetchData()
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.fetchSummary())
  }
}
</script>
